import { KeyValueModel } from "./key-value.model";

export class ModuleFormModel {
    companyAuditModuleId: string;
    keyValues: KeyValueModel[];
    close: boolean;
}
